let idCounter = 0;

export function createId() {
    console.log('createId', idCounter);
    return 'fake' + idCounter++;
}